import * as React from 'react';

import type {ThreadStatus} from 'nutshell-graphql-types';

import {StackLegacy} from '../../layout/stack/stack-legacy';
import {SelectPickerGeneric} from '../../select-picker-generic/select-picker-generic';

import type {UpdateAction} from '../types';

import {getStatusOptions} from './helpers';

type Props = {
    onUpdateStatus: (action: UpdateAction) => Promise<any> | null | undefined;
    status: ThreadStatus | null | undefined;
    canReopen: boolean;
    canArchive: boolean;
    assigneeButton: React.ReactNode | null | undefined;
    isSmall?: boolean;
};

export function ThreadHeaderPickers(props: Props) {
    if (!props.onUpdateStatus && !props.assigneeButton) {
        return null;
    }

    const options = getStatusOptions(props.status, props.canReopen, props.canArchive);
    const value = options.find((option) => option.value === props.status);

    return (
        <StackLegacy isHorizontal={true} spacing={props.isSmall ? 8 : 16} alignCenter={true}>
            {props.assigneeButton}
            <div style={{width: '100px'}}>
                <SelectPickerGeneric
                    name='thread-status'
                    isSearchable={false}
                    options={options}
                    value={value}
                    // @ts-expect-error
                    onChange={(action) => {
                        if (props.onUpdateStatus) {
                            props.onUpdateStatus(action.value);
                        }
                    }}
                    styles={{
                        // @ts-expect-error
                        menu: (base) => ({
                            ...base,
                            zIndex: 11,
                        }),
                    }}
                />
            </div>
        </StackLegacy>
    );
}
